import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import "component/modal/Reject/styles.scss";

interface RejectModalProps {
  isOpen: boolean;
  onReject: () => void;
  onClose: () => void;
}

function RejectModal(props: RejectModalProps) {
  const { isOpen, onReject, onClose } = props;
  const { t } = useTranslation("translation");
  const modalRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
        onClose();
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  if (!isOpen) return null;

  return (
    <div className="reject-container modal" role="dialog">
      <div
        className="modal-dialog modal-dialog-centered"
        role="document"
        ref={modalRef}
      >
        <div className="modal-content">
          <div className="modal-body">
            <div className="question">{t("rejectFreeSpins")}</div>
            <div className="button-group">
              <button className="btn text-nowrap w-100 reject-button" onClick={onReject}>
                {t("reject")}
              </button>
              <button className="btn text-nowrap w-100 no-button" onClick={onClose}>
                {t("no")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RejectModal;
